import { UserProfileResponse } from '../../types/authentication';
import { getPatientSiteIds } from '../../utils/patient';
import { UserData } from '../../types/users';
import { useMergedSiteSettings } from '../../query/sites';

export const usePatientSiteSettings = (
  user?: UserProfileResponse | UserData,
) => {
  const siteIds = user && getPatientSiteIds(user);
  const { data: siteSettings, isLoading } = useMergedSiteSettings(siteIds);
  return {
    siteSettings,
    isLoading,
  };
};
